import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { observer } from "mobx-react";
import { __ } from "../../../utils";
import { useStores } from "../../../store";
import { useScannerProgress } from "../../../hooks";
import { ConfigContent } from "../content";
import { Divider, Spin } from "antd";
import { ScannerCards } from "@devowl-wp/react-cookie-banner-admin";
import { ScannerTemplateCardActionOpenExternalUrlsTable } from ".";
import { yieldMainThread } from "@devowl-wp/react-utils";
const ScannerTemplateCards = observer(()=>{
    const [busy, setBusy] = useState(false);
    const { scannerStore, cookieStore, optionStore: { isTcf } } = useStores();
    const { sortedTemplates, resultTemplates, busyResultTemplates } = scannerStore;
    const { remaining } = useScannerProgress();
    const { essentialGroup } = cookieStore;
    const [hasModalOpen, setHasModalOpen] = useState(false);
    const handleSelect = useCallback(async (template)=>{
        if (hasModalOpen || !template || busy) {
            return;
        }
        setBusy(true);
        const { identifier, isHidden, name } = template;
        const scannerResultModel = scannerStore.resultTemplates.get(identifier);
        const { type, templateModel } = scannerResultModel;
        // Always navigate back to the scanner results
        const navigateAfterCreation = `navigateAfterCreation=${encodeURIComponent("#scanner")}`;
        if (type === "service") {
            yieldMainThread().then(()=>window.location.href = `#/cookies/${essentialGroup == null ? void 0 : essentialGroup.key}/new?force=${identifier}&${navigateAfterCreation}`);
        } else {
            const blockerTemplateModel = templateModel;
            await blockerTemplateModel.fetchUse();
            const { use: { consumerData: { serviceTemplates, createAdNetwork } } } = blockerTemplateModel;
            const firstTemplate = serviceTemplates.filter((param)=>{
                let { identifier: blockerServiceTemplateIdentifier } = param;
                return blockerServiceTemplateIdentifier === identifier;
            })[0] || serviceTemplates[0];
            // The blocker template has a services, so we can safely create a service for it
            let navigateTo = "";
            if (firstTemplate) {
                if (!firstTemplate.consumerData.isCreated || isHidden) {
                    if (isHidden) {
                        // It is a hidden content blocker, so we can only create a service
                        navigateTo = `#/cookies/${essentialGroup == null ? void 0 : essentialGroup.key}/new?force=${identifier}&${navigateAfterCreation}`;
                    } else if (!firstTemplate.consumerData.isCreated) {
                        var _firstTemplate_group;
                        // Service does not exist -> directly navigate to the service and force content blocker to be created
                        navigateTo = `#/cookies/${essentialGroup == null ? void 0 : essentialGroup.key}/new?force=${firstTemplate.identifier}&attributes=${JSON.stringify({
                            createContentBlocker: ((_firstTemplate_group = firstTemplate.group) == null ? void 0 : _firstTemplate_group.toLowerCase()) !== (essentialGroup == null ? void 0 : essentialGroup.data.name.toLowerCase()),
                            createContentBlockerId: identifier
                        })}&${navigateAfterCreation}`;
                    }
                } else {
                    // Service already exists -> directly navigate to the content blocker
                    navigateTo = `#/blocker/new?force=${identifier}&${navigateAfterCreation}`;
                }
            } else if (createAdNetwork) {
                if (isTcf) {
                    // We need to create a TCF adsense network for this vendor
                    navigateTo = `#/cookies/tcf-vendors/new?adNetwork=${encodeURIComponent(createAdNetwork)}`;
                } else {
                    // We first need to activate TCF
                    navigateTo = `#/settings/tcf?tcfIntegrationItem=${encodeURIComponent(name)}&navigateAfterTcfActivation=${encodeURIComponent(`#/cookies/tcf-vendors/new?adNetwork=${encodeURIComponent(createAdNetwork)}`)}`;
                }
            }
            if (navigateTo) {
                yieldMainThread().then(()=>window.location.href = navigateTo);
            }
        }
        setBusy(false);
    }, [
        busy,
        hasModalOpen,
        essentialGroup
    ]);
    return /*#__PURE__*/ _jsxs(ConfigContent, {
        style: {
            textAlign: "center"
        },
        children: [
            /*#__PURE__*/ _jsx(Divider, {
                children: __("Services, for which you should obtain consent")
            }),
            /*#__PURE__*/ _jsx(Spin, {
                spinning: busyResultTemplates && !remaining || busy,
                children: /*#__PURE__*/ _jsx(ScannerCards, {
                    templates: sortedTemplates.map((param)=>{
                        let { data } = param;
                        return data;
                    }),
                    onSelect: handleSelect,
                    dropdownItems: (param)=>{
                        let { identifier, consumerData: { scan } } = param;
                        return [
                            scan && {
                                key: "table",
                                label: /*#__PURE__*/ _jsx(ScannerTemplateCardActionOpenExternalUrlsTable, {
                                    template: resultTemplates.get(identifier),
                                    onVisibleChange: setHasModalOpen
                                }, "table")
                            }
                        ];
                    },
                    onIgnoreToggle: (template, state)=>scannerStore.resultTemplates.get(template.identifier).ignore(state)
                })
            })
        ]
    });
});
export { ScannerTemplateCards };
